// ** IMPORTANT **: Keep in sync with functions/src/index.ts BOOK_INVITE_ACTION_CALLABLE_ERROR_REASON
export enum BOOK_INVITE_ACTION_CALLABLE_ERROR_REASON {
    recipientHasActiveWebBookAccess = 'recipient-has-active-web-book-access',
    noUnassignedInvites = 'no-unassigned-invites',
    inviteNotPending = 'invite-not-pending',
    invitePoolNotFound = 'invite-pool-not-found',
}
